import * as React from 'react';
import classNames from 'classnames';
import Text from '../../atoms/Text';

import styles from './Select.module.scss';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  disabled?: boolean;
  children: React.ReactNode;
  description?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  ellipsize?: boolean;
}

export const SelectItem: React.FunctionComponent<Props> = ({
  className,
  style,
  children,
  description,
  disabled,
  onClick,
  ellipsize = true,
  ...htmlElementProps
}) => (
  <button
    type="button"
    className={classNames(styles.item, className, {
      disabled,
      ellipsize,
    })}
    onClick={onClick}
    {...htmlElementProps}
  >
    <Text as="span" size="sm2" weight="bold">
      {children}
    </Text>
    {description && (
      <Text size="sm2" color="gray100">
        {description}
      </Text>
    )}
  </button>
);

export default SelectItem;
